import * as React from 'react';
import './CancellationPolicyForCoach.module.scss';

export const CancellationPolicyForCoach = () => (
  <div styleName="cancellation-policy">
    <div styleName="header">
      当日欠勤は、受講者も
      <br styleName="sp-only" />
      困ってしまうのでお控え下さい
    </div>
    <ul styleName="body">
      <li>
        万が一、欠勤される場合は<span styleName="red">前日まで</span>にご連絡をお願い致します。
      </li>
      <li>コーチング開始時刻の6時間前を過ぎてのご連絡は無断欠勤扱いとなりますのでご了承下さい。</li>
      <li>無断欠勤をされた場合は、欠勤分を別日でシフトに入っていただきます。</li>
      <li>※欠勤振替分のお給料はお支払いできないのでご了承ください。</li>
    </ul>
  </div>
);
